import { render, staticRenderFns } from "./UserSettingsChangePassword.vue?vue&type=template&id=1fbdd420"
import script from "./UserSettingsChangePassword.vue?vue&type=script&lang=js"
export * from "./UserSettingsChangePassword.vue?vue&type=script&lang=js"
import style0 from "./UserSettingsChangePassword.vue?vue&type=style&index=0&id=1fbdd420&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports